import "../../styles/titleHeading.css";
import React from "react";
import { useTranslation } from "react-i18next";
import BlurText from "@/components/reactbits/BlurText";
import { usePrefersReducedMotion } from "@/hooks/usePrefersReducedMotion";

type TitleHeadingProps = {
    backdropText?: string;
    cjk?: boolean;
}

export const TitleHeading: React.FC<React.HTMLProps<HTMLHeadingElement> & TitleHeadingProps> =
    ({className, children, backdropText, cjk}) => {
    const { i18n } = useTranslation();
    const reducedMotion = usePrefersReducedMotion();
    const animateText = typeof children === "string" && children.length > 0 && !reducedMotion;
    const byLetters = i18n.language.startsWith("zh");

    return (
        <h2 className={`${className} title-heading${cjk ? ' cjk-heading' : ''} text-theme-primary`}
            data-backdrop-text={backdropText || children}
            aria-label={animateText ? children : undefined}>
            {animateText ? (
                <span aria-hidden="true">
                    <BlurText
                        text={children}
                        animateBy={byLetters ? "letters" : "words"}
                        delay={byLetters ? 60 : 110}
                        stepDuration={0.3}
                        threshold={0.4}
                    />
                </span>
            ) : children}
        </h2>
    );
};
